/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Collection methods
 * -----------------------------------------------------------------------------
 *
 * @namespace Listcollection
 */

import axios from 'axios';
import Flickity from 'flickity';
import detectIt from 'detect-it';

const createHistory = require('history').createBrowserHistory;

const history = createHistory();

const collectionListMethods = {

  data() {
    return {
      isCollectionAjaxed: false,
      collections_col: {
        collection: [],
        pagination: {},
        activeFilters: [],
      },
    };
  },

  methods: {
    _initListCollection() {
      // stop parsing if we are not in the collection template
      if (app.currentTemplate !== 'list-collections') {
        return;
      }

      $(app.selectors.collprObj).each((ind, item) => {
        const collObj = $(item).html();
        const collData = JSON.parse(collObj);
        let priority_img = '';
        const coll_handle = collData.collection.handle.replace('-ab-testing', '');
        let product_tags = [];
        collData.products.forEach((item_prod) => {
          item_prod.tags.forEach((tag) => {
            if (tag.indexOf('priority') >= 0) {
              priority_img = tag.replace('priority-', '');
            }
            item_prod.priority_img = priority_img;
          let available_tag = true;

            for (let i = 0; i < product_tags.length; i++) {
              if (product_tags[i].handle == tag) {
                available_tag = false;
                return false;
              }
            }

            if (available_tag && tag.indexOf('priority') < 0 && tag.indexOf(coll_handle) > -1) {
              let coll_pro_tag = {};
              coll_pro_tag.handle = tag;
              let tag_title = tag.replace(/[-\s]/g, ' ').trim();
              coll_pro_tag.title = tag_title;
              product_tags.push(coll_pro_tag);
            }
          });
        });
        if (product_tags.length) {
          collData.collection.tags = product_tags;
        } else {
          collData.collection.tags = '0';
        }
        app.collections_col.collection.push(collData);
      });

      app._initCollFilters();
    },

    _initCollFilters() {
      Shopify.queryParams = {};

      history.listen((location, action) => {
        app._runCollFilters(); // run every time history changes
      });

      // run one time during 1st page load or upon page refresh
      app._runCollFilters();
    },

    _runCollFilters() {
      app._urlCollParams();
      app._mapCollFilters();
      const url = app._CreateUrl();
    },

    /**
     * Event when an input filter changes
     *
     */
    _parseCollFilters(event) {
      const filterType = $(event.currentTarget).data('filter-type');
      const collectionHandle = $(event.currentTarget).data('handle');
      const selectedTags = [];

      
      // Collection filtering
      if (filterType === 'collection') {
        let newURL = '';
        let search = $.param(Shopify.queryParams);
        let href = $(event.currentTarget).attr('href');

        if (app.isCollectionAjaxed) {
          if (!search.length) {
            href += '?';
          }
          app._filterAjaxCall(href);
        } else {
          newURL = collectionHandle;
          if (selectedTags.length) {
            newURL += `/${selectedTags.join('+')}`;
          }
          delete Shopify.queryParams.page;
          search = $.param(Shopify.queryParams);
          if (search.length) {
            newURL += `?${search}`;
          }
          location.href = newURL;
        }
      }

      // Tag filter
      if (filterType === 'tag') {
        
        $('[data-filter]:checked').each(function(i) {
          selectedTags.push(this.value);
        });

        app.collections_col.activeFilters = selectedTags;

        if (selectedTags.length) {
          Shopify.queryParams.constraint = selectedTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }

        if (app.isCollectionAjaxed) {
          // app._filterAjaxCall();
        } else {
          delete Shopify.queryParams.page;
          location.search = $.param(Shopify.queryParams).replace(/%2B/g, '+');
        }
      }


      // map all filters
      app._mapCollFilters();
    },

    /**
     * Get all parameters from URL and map them to all inputs in page
     *
     */
    _mapCollFilters() {
      // Read url parameters and map keys to filters
      if (location.search.length) {
        for (let aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i += 1) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      // sorting: select value
      if (Shopify.queryParams.sort_by) {
        $('[data-filter-sort]').val(Shopify.queryParams.sort_by);
      } else {
        $('data-filter-sort').val('manual');
      }

      // tags: select values
      if (Shopify.queryParams.constraint) {
        const selectedTags = [];
        $.each(Shopify.queryParams.constraint.split('+'), (i, val) => {
          if (val) {
            selectedTags.push(val);
          }
        });

        app.collections_col.activeFilters = selectedTags;
      }
    },

    _CreateUrl(e) {
      const b = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      return e ? b !== '' ? `${e}?${b}` : e : `${location.pathname}?${b}`;
    },

    _urlCollParams() {
      if (Shopify.queryParams === {}, location.search.length) {
        for (let i, e = 0, t = location.search.substr(1).split('&'); e < t.length; e += 1) {
          i = t[e].split('='), i.length > 1 && (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]));
        }
      }
    },

    _clearAllFilters() {
      delete Shopify.queryParams.constraint;
      delete Shopify.queryParams.q;
      app.collections_col.activeFilters = [];

      if (app.isCollectionAjaxed) {
        $('[data-filter]').attr('checked', false);
      } else {
        location.search = $.param(Shopify.queryParams);
      }
    },
  },

};

export default collectionListMethods;

